<div class="container">
  <h2 class="header">{{ 'Order.AddOrder' | translate }}</h2>

  <mat-horizontal-stepper linear #stepper>
    <!-- Step 1: Podstawowe informacje -->
    <mat-step [stepControl]="orderForm">
      <ng-template matStepLabel>{{ 'Order.BasicInformation' | translate }}</ng-template>
      <form [formGroup]="orderForm">
        <div class="order-items" formArrayName="orderItems">
          @for (item of orderItems.controls; track item; let i = $index) {
            <div class="row" [formGroupName]="i">
              <div class="col-12 col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Order.NumberOfPeople' | translate }}</mat-label>
                  <input matInput type="number" formControlName="employeesNumber" min="1" max="1000" />
                </mat-form-field>
              </div>
              <div [ngClass]="{ 'col-12 col-lg-5': canRemoveOrderItems(), 'col-12 col-lg-6': !canRemoveOrderItems() }">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Order.OrderSpecification' | translate }}</mat-label>
                  <mat-select formControlName="positionExpectation">
                    @for (option of filteredPositionExpectations$ | async; track option) {
                      <mat-option [value]="option">
                        {{ option.Name }} ({{ option.EmployerObjectName }})
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-lg-3">
                <mat-form-field appearance="outline">
                  <mat-label [matTooltip]="'Order.StartDate' | translate">{{ 'Order.StartDate' | translate }}</mat-label>
                  <input matInput [matDatepicker]="pickerStart" formControlName="startDate" [matDatepickerFilter]="startDateFilter" />
                  <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                  <mat-datepicker #pickerStart></mat-datepicker>
                </mat-form-field>
              </div>
              @if (canRemoveOrderItems()) {
                <div class="col-12 col-lg-1 text-right">
                  <button mat-icon-button color="warn" (click)="removeItem(i)">
                    <mat-icon>remove_circle</mat-icon>
                  </button>
                </div>
              }
            </div>
          }
        </div>
      </form>
      <div class="form-actions">
        <button mat-raised-button color="primary" (click)="addItem()" [disabled]="!canAddOrderItems()">
          <mat-icon>add_circle</mat-icon> {{ 'Order.AddAnotherItem' | translate }}
        </button>
        <button mat-raised-button color="primary" class="ml-2" (click)="submitOrder()" [disabled]="!orderForm.valid">
          {{ 'Order.SubmitOrder' | translate }}
        </button>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
